import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';
import { Subject, Observable, firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class I18NService {
  constructor(private translate: TranslateService, private http: HttpClient) {}

  translateJson(json) {
    this.translate.setTranslation(this.translate.currentLang, json);
  }

  changeLang(lang) {
    // this language will be used as a fallback when a translation isn't found in the current language
    this.translate.setDefaultLang(lang);
    // the lang to use, if the lang isn't available, it will use the current loader to get them
    this.translate.use(lang);

    // this.getJsonTranslate();
    this.getJsonTranslateRequest();
  }

  /** return current language */
  getCurrentLang() {
    return this.translate.currentLang;
  }

  /** return current language */
  getDefaultLang() {
    return this.translate.defaultLang;
  }

  /** Call the local service that returns the json with the current language */
  async getJsonTranslate(lang?: string, prefix?: string) {
    if (prefix == undefined) prefix = '';
    this.translate.currentLoader['prefix'] = prefix;
    let current_lang = lang ? lang : this.getDefaultLang();
    let jsonRequest = prefix + '/assets/i18n/' + current_lang + '.json';
    let translateRequestPromise = firstValueFrom(this.http.get(jsonRequest));

    //translate.use bisogna chiamarlo subito per settare la lingua corrente e poi prendere il file json
    await this.translate.use(current_lang);
    await translateRequestPromise.then(
      (resp) => {
        this.translateJson(resp);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  /** Call the api service that returns the json with the current language */
  async getJsonTranslateRequest(lang?: string, application?: string) {
    let current_lang = lang ? lang : this.getCurrentLang();
    let app = application ? application : 'portale-saas';

    this.http.post('/api/translation/get', { lang: current_lang, application: app }).subscribe(
      (resp: any) => {
        if (resp && resp.error == 0) {
          this.translateJson(resp.data);
        } else {
          if (app == 'portale-web-admin') {
            this.getJsonTranslate(lang, '/admin');
          } else {
            this.getJsonTranslate(lang);
          }
        }
      },
      (err) => {
        if (app == 'portale-web-admin') {
          this.getJsonTranslate(lang, '/admin');
        } else {
          this.getJsonTranslate(lang);
        }
      }
    );
  }

  /** Returns the translated string */
  getTranslateParameter(key: string, value?: string): string {
    let subject = new Subject<string>();
    let result = '';
    this.translate.get(key, { value: value }).subscribe((res) => {
      result = res;
    });
    return result;
  }

  /** Returns the Observable<string> */
  getAsyncTranslateParameter(key: string, value?: string) {
    let translation = this.translate.instant(key);
    if (translation == key) {
      return new Observable((subscriber) => {
        subscriber.next(translation);
        subscriber.complete();
      });
    }
    return this.translate.get(key, { value: value });
  }

  getInstantValue(key: string) {
    return this.translate.instant(key);
  }

  getAsyncTranslateMultiParameters(key: string[]) {
    return this.translate.get(key);
  }
}
